module.exports = __webpack_public_path__ + "img/dynamic-28.9c5cb20b.png";